"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _HeaderBarLinks = _interopRequireDefault(require("./HeaderBarLinks"));
var _LoginLink = _interopRequireDefault(require("./LoginLink"));
var _LogoutLink = _interopRequireDefault(require("./LogoutLink"));
var _WelcomeMessage = _interopRequireDefault(require("./WelcomeMessage"));
var _MultiSiteDropDown = _interopRequireDefault(require("./multi-site/MultiSiteDropDown"));
var _ContactUs = _interopRequireDefault(require("./ContactUs"));
var _SwitchUser = _interopRequireDefault(require("./SwitchUser"));
var _ApplicationContext = require("../../api/ApplicationContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const isPopup = () => window.opener && window.opener !== window;
const UserBar = _ref => {
  let {
    activeClass,
    isAuthenticated,
    welcome,
    isActive,
    toggleActive,
    superUser,
    headerLinks,
    contactUs,
    slimView,
    loginLink,
    loginPath,
    logoutLink,
    logoutPath,
    profilePath
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `navbar-user ${activeClass}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container navbar"
  }, /*#__PURE__*/_react.default.createElement(_WelcomeMessage.default, {
    isDesktop: false,
    key: `WelcomeMessage2${isAuthenticated}`,
    customWelcome: welcome
  }), !isPopup() && /*#__PURE__*/_react.default.createElement("div", {
    className: "navbar-end"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "navbar-footer"
  }, /*#__PURE__*/_react.default.createElement(_MultiSiteDropDown.default, {
    toggleActive: toggleActive,
    isActive: isActive,
    key: `MultiSiteDropDown${isAuthenticated}`
  }), _ApplicationContext.ApplicationContext.isRunAs() && superUser !== null && /*#__PURE__*/_react.default.createElement(_SwitchUser.default, {
    key: `SwitchConsultantLinks${isAuthenticated}`
  }), headerLinks && headerLinks, contactUs || /*#__PURE__*/_react.default.createElement(_ContactUs.default, null), !slimView && (loginLink || /*#__PURE__*/_react.default.createElement(_LoginLink.default, {
    loginPath: loginPath,
    key: `LoginLink${isAuthenticated}`
  })), logoutLink || /*#__PURE__*/_react.default.createElement(_LogoutLink.default, {
    logoutPath: logoutPath,
    key: `LogoutLink${isAuthenticated}`
  })), _ApplicationContext.ApplicationContext.isProfile() && /*#__PURE__*/_react.default.createElement(_HeaderBarLinks.default, {
    profilePath: profilePath,
    key: `HeaderBarLinks${isAuthenticated}`
  }))));
};
UserBar.propTypes = {
  activeClass: _propTypes.default.string,
  isAuthenticated: _propTypes.default.bool,
  isActive: _propTypes.default.bool,
  toggleActive: _propTypes.default.func,
  superUser: _propTypes.default.shape({
    firstName: _propTypes.default.string,
    lastName: _propTypes.default.string
  }),
  loginPath: _propTypes.default.string,
  logoutPath: _propTypes.default.string,
  profilePath: _propTypes.default.string,
  history: _propTypes.default.shape({
    listen: _propTypes.default.func.isRequired
  }),
  location: _propTypes.default.shape({
    pathname: _propTypes.default.string
  }),
  contactUs: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.element, _propTypes.default.object]),
  loginLink: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.element, _propTypes.default.object]),
  logoutLink: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.element, _propTypes.default.object]),
  welcome: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.element, _propTypes.default.object]),
  site: _propTypes.default.shape({
    public: _propTypes.default.shape({
      isMegaMenu: _propTypes.default.bool
    })
  }),
  headerLinks: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.element, _propTypes.default.object]),
  slimView: _propTypes.default.bool
};
var _default = exports.default = UserBar;
//# sourceMappingURL=UserBar.js.map